(function () {
  'use strict';
  function initAddons(container) {
    if (container.dataset.addonsInit === '1') return;
    var wrapper = container.closest('[data-product-form-wrapper]');
    var form = document.getElementById(container.dataset.formId);
    if (!wrapper || !form) return;
    var button = form.querySelector('[data-add-to-cart]');
    var baseSelect = container.querySelector('[data-addon-base]');
    var json = form.querySelector('[data-product-json]');
    if (!button || !baseSelect || !json) return;
    var product;
    try { product = JSON.parse(json.textContent); } catch (_) { return; }
    container.dataset.addonsInit = '1';
    var error = container.querySelector('[data-addon-error]');
    var busy = false;
    var formatter = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
      style: 'currency', currency: container.dataset.currency || 'USD'
    });
    function money(cents) { return formatter.format(cents / 100); }
    function base() { return product.variants.find(function (v) { return String(v.id) === baseSelect.value; }); }
    function choices() { return Array.from(container.querySelectorAll('[data-addon-choice]:checked')).filter(function (el) { return el.value && !el.disabled; }); }
    function quantity() {
      var value = new FormData(form).get('quantity');
      return value === null ? 1 : Number(value);
    }
    function showError(message) { error.textContent = message; error.hidden = !message; }
    function recalc() {
      var selected = base();
      var extra = choices().reduce(function (total, el) { return total + Number(el.dataset.price); }, 0);
      var qty = quantity();
      var valid = selected && selected.available && Number.isInteger(qty) && qty > 0;
      container.querySelector('[data-addon-total]').textContent = money(extra);
      var total = selected ? (selected.price + extra) * (valid ? qty : 1) : 0;
      container.querySelector('[data-addon-configured-total]').textContent = money(total);
      var buttonPrice = button.querySelector('[data-button-price]');
      if (buttonPrice) buttonPrice.textContent = money(total);
      button.disabled = busy || !valid;
      button.setAttribute('aria-busy', String(busy));
    }
    function syncBase() {
      var selected = base();
      if (!selected) return;
      var options = Array.from(container.querySelectorAll('[data-addon-base-option]'));
      options.forEach(function (el, index) { el.value = selected.options[index]; });
      // Set all native options first so Pipeline never resolves an intermediate variant.
      if (options.length) options[options.length - 1].dispatchEvent(new Event('change', { bubbles: true }));
      form.querySelector('[name="id"]').value = String(selected.id);
      recalc();
    }
    baseSelect.addEventListener('change', syncBase);
    wrapper.addEventListener('change', recalc);
    wrapper.querySelectorAll('[name="quantity"]').forEach(function (input) {
      input.addEventListener('input', recalc);
      input.addEventListener('change', recalc);
    });
    var section = wrapper.closest('[data-section-id]');
    if (section) section.addEventListener('theme:variant:change', recalc);
    async function addConfiguration(event) {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (busy) return;
      showError('');
      if (!form.reportValidity()) return;
      var selected = base();
      var qty = quantity();
      if (!selected || !selected.available || !Number.isInteger(qty) || qty < 1) {
        showError('Choose an available configuration and a valid quantity.');
        return;
      }
      var selectedChoices = choices();
      var data = new FormData(form);
      var properties = {};
      data.forEach(function (value, name) {
        var match = name.match(/^properties\[(.+)\]$/);
        if (match && typeof value === 'string') properties[match[1]] = value;
      });
      var configuration = window.crypto.randomUUID();
      if (selectedChoices.length) properties._ae_configuration = configuration;
      var main = { id: selected.id, quantity: qty, properties: properties };
      var plan = data.get('selling_plan');
      if (plan) main.selling_plan = Number(plan);
      var items = [main].concat(selectedChoices.map(function (el) {
        return { id: Number(el.value), quantity: qty, parent_id: selected.id,
          properties: { Configuration: selected.title, _ae_configuration: configuration } };
      }));
      busy = true;
      recalc();
      container.querySelectorAll('select, input:not([type="hidden"])').forEach(function (el) {
        el.dataset.wasDisabled = String(el.disabled);
        el.disabled = true;
      });
      var cartRoute = (window.theme && window.theme.routes && window.theme.routes.cart) || ((window.Shopify && window.Shopify.routes.root) || '/') + 'cart';
      try {
        var response = await fetch(cartRoute + '/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        });
        var result = await response.json();
        if (!response.ok || result.status >= 400) {
          throw new Error((typeof result.description === 'string' ? result.description : 'We could not add this configuration.') + ' Please review your cart before trying again.');
        }
        window.location.assign(cartRoute);
      } catch (err) {
        showError(err.message || 'The request could not be completed. Please review your cart before trying again.');
        busy = false;
        container.querySelectorAll('[data-was-disabled]').forEach(function (el) {
          el.disabled = el.dataset.wasDisabled === 'true';
          delete el.dataset.wasDisabled;
        });
        recalc();
      }
    }
    // Capture before Pipeline's click handler; also cover keyboard submission.
    wrapper.addEventListener('click', function (event) {
      if (event.target.closest('[data-add-to-cart]') === button) addConfiguration(event);
    }, true);
    form.addEventListener('submit', addConfiguration, true);
    syncBase();
  }
  function initAll() { document.querySelectorAll('[data-product-addons]').forEach(initAddons); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
